// @flow
import runtimeEnv from "@mars/heroku-js-runtime-env"
const env = runtimeEnv()

export const PROTOCOL: string = env.REACT_APP_API_BASE_PROTOCOL || "http"
export const DOMAIN: string = env.REACT_APP_API_DOMAIN || "localhost"
export const PORT: ?string = env.REACT_APP_API_PORT
export const USABLE_PORT = PORT ? `:${PORT}` : ""
export const MAPBOX_ACCESS_TOKEN: ?string = env.REACT_APP_MAPBOX_ACCESS_TOKEN



// WEBPACK FOOTER //
// ./src/API/config.js